var map = {
	"./authentication/authentication.module": [
		"./src/app/authentication/authentication.module.ts",
		"authentication-authentication-module"
	],
	"./project/web/activity/activity.module": [
		"./src/app/project/web/activity/activity.module.ts",
		"default~project-web-activity-activity-module~project-web-advertisement-advertisement-module~project-~b526babe",
		"default~project-web-activity-activity-module~project-web-advertisement-advertisement-module~project-~81cc0f20",
		"default~project-web-activity-activity-module~project-web-announcement-announcement-module~project-we~faa1634e",
		"default~project-web-activity-activity-module~project-web-blog-blog-module~project-web-gallery-galler~5e707499",
		"common",
		"project-web-activity-activity-module"
	],
	"./project/web/advertisement/advertisement.module": [
		"./src/app/project/web/advertisement/advertisement.module.ts",
		"default~project-web-activity-activity-module~project-web-advertisement-advertisement-module~project-~b526babe",
		"default~project-web-activity-activity-module~project-web-advertisement-advertisement-module~project-~81cc0f20",
		"common",
		"project-web-advertisement-advertisement-module"
	],
	"./project/web/announcement/announcement.module": [
		"./src/app/project/web/announcement/announcement.module.ts",
		"default~project-web-activity-activity-module~project-web-advertisement-advertisement-module~project-~b526babe",
		"default~project-web-activity-activity-module~project-web-announcement-announcement-module~project-we~faa1634e",
		"common",
		"project-web-announcement-announcement-module"
	],
	"./project/web/blog/blog.module": [
		"./src/app/project/web/blog/blog.module.ts",
		"default~project-web-activity-activity-module~project-web-advertisement-advertisement-module~project-~b526babe",
		"default~project-web-activity-activity-module~project-web-advertisement-advertisement-module~project-~81cc0f20",
		"default~project-web-activity-activity-module~project-web-announcement-announcement-module~project-we~faa1634e",
		"default~project-web-activity-activity-module~project-web-blog-blog-module~project-web-gallery-galler~5e707499",
		"default~project-web-blog-blog-module~project-web-venue-venue-module",
		"common",
		"project-web-blog-blog-module"
	],
	"./project/web/catalogue/catalogue.module": [
		"./src/app/project/web/catalogue/catalogue.module.ts",
		"default~project-web-activity-activity-module~project-web-advertisement-advertisement-module~project-~b526babe",
		"default~project-web-activity-activity-module~project-web-advertisement-advertisement-module~project-~81cc0f20",
		"default~project-web-activity-activity-module~project-web-announcement-announcement-module~project-we~faa1634e",
		"common",
		"project-web-catalogue-catalogue-module"
	],
	"./project/web/gallery/gallery.module": [
		"./src/app/project/web/gallery/gallery.module.ts",
		"default~project-web-activity-activity-module~project-web-advertisement-advertisement-module~project-~b526babe",
		"default~project-web-activity-activity-module~project-web-advertisement-advertisement-module~project-~81cc0f20",
		"default~project-web-activity-activity-module~project-web-blog-blog-module~project-web-gallery-galler~5e707499",
		"common",
		"project-web-gallery-gallery-module"
	],
	"./project/web/resource/resource.module": [
		"./src/app/project/web/resource/resource.module.ts",
		"default~project-web-activity-activity-module~project-web-advertisement-advertisement-module~project-~b526babe",
		"common",
		"project-web-resource-resource-module"
	],
	"./project/web/venue/venue.module": [
		"./src/app/project/web/venue/venue.module.ts",
		"default~project-web-activity-activity-module~project-web-advertisement-advertisement-module~project-~b526babe",
		"default~project-web-activity-activity-module~project-web-advertisement-advertisement-module~project-~81cc0f20",
		"default~project-web-activity-activity-module~project-web-announcement-announcement-module~project-we~faa1634e",
		"default~project-web-activity-activity-module~project-web-blog-blog-module~project-web-gallery-galler~5e707499",
		"default~project-web-blog-blog-module~project-web-venue-venue-module",
		"common",
		"project-web-venue-venue-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;